<template>

<div class="mt-2">
    <div v-if='isReady'>

<!--         <div v-if='type == "auction"' class="col-lg-5 order-lg-2 mb-4 mb-lg-0">
            <div class="bg-light-green p-30 h-100 mb-0">
                <h3 class="mb-2">Как да участваш?</h3>
                <p>
                    За да вземеш участваш в този търг е необходимо да посочиш срок, в който можеш да изпълниш работата и възнаграждение за труда си, което смяташ за справедливо.
                </p>
                <p>
                    След като Възложителя избере оферта, ще получиш известие дали победителят си ти.
                </p>
                <p class="mb-0">
                    <strong>Важно е да имаш готовност да започнеш веднага работа.</strong> Неизпълнение
                    на поетия ангажимент ще доведе до намаляване на рейтинга ти.
                </p>
            </div>
        </div>
   
        <div v-if='type == "competition"' class="col-lg-5 order-lg-2 mb-4 mb-lg-0">
            <div class="bg-light-green p-30 h-100 mb-0">
                <h3 class="mb-2">Как да участваш?</h3>
                <p>
                    За да вземеш участвате в този конкурс е необходимо да въведете заглавие и описание на предложението ви.
                </p>
                <p>
                    След като се запишете за участие, ще можете да добавяте изображения към него до края на периода. 
                <p>
                    Когато изтече времето за етапа, възложителя ще избере победител.
                </p>
            </div>
        </div> -->
        <div v-if='!offer' class="row">

            <div class="col-12 mb-4">
                <div class="auction-item shadow d-flex justify-content-center align-items-center h-100 pb-4 pt-0">

                    <phase-timer v-if='$parent.phase.type == "auction"' :end='$parent.projectPhase.end_date'
                                :msg='timerMessage' t='Време за подаване на оферти:'></phase-timer>

                    <phase-timer v-if='$parent.phase.type == "competition" && !offer' :end='$parent.projectPhase.apply_end'
                                :msg='timerMessage' t='Време за заявка за участие в конкурс:'></phase-timer>

                </div>
            </div>

            <div class="col-lg-12">
                <fieldset class="fieldset h-100 mb-0">
                    <auction-form v-if='type == "auction"'></auction-form>
                    <competition-form v-if='type == "competition"'></competition-form>
                </fieldset>
            </div>
        </div>

        <div v-if='offer' class="row">
            <div  class="col-12 mb-4">
                <div class="auction-item auction-loading shadow d-flex justify-content-center align-items-center h-100">

                    <phase-timer v-if='$parent.phase.type == "competition" && offer' :end='$parent.projectPhase.end_date'
                                :msg='timerMessage' t='Краен срок за предаване на идейното предложение:'></phase-timer>

                    <phase-timer v-else :end='$parent.projectPhase.end_date' 
                                :msg='timerMessage' t='До края на етапа остават:'></phase-timer>
                </div>
            </div>
            <div class="col-12">
                <div v-if='type == "auction"' class="fieldset mb-0">
                    <my-auction-offer :offer='offer'></my-auction-offer>
                </div>

                <my-competition-offer v-if='type == "competition"' :offer='offer'></my-competition-offer>

            </div>
        </div>
    </div>
    
    <div v-if='!isReady' class="row d-flex justify-content-center">
        <img src='/resources/loader.svg'>
    </div>

</div>

</template>

<script>
    export default {

        mounted() {

        },

        created() {

            this.getData();

            this.checkFinished();

        },

        data() {
            return {

                timerMessage : 'Времето е изтекло',
                isReady : false,
                offer   : false,
                finished : false,

                type : this.$parent.phase.type,
                projectPhase : this.$parent.projectPhase,

                auctionMdl : {
                    time : 0,
                    cost : 0
                },

                competitionMdl : {
                    title : '',
                    desc  : ''
                },
            }
        },

        methods : {

            //Get the logged-in worker offer
            getData() {
                var me = this;
    
                this.ajax.call('phs:gwo', { pr : this.$parent.project.id, ph : this.$parent.phase.id }, (r) => {
                   
                    if( r.status == 'success' ) {

                        if( !r.data ) {
                            //No offer submited from logged user


                        } else {

                            if( me.type == 'auction' ) {
                                me.offer = Object.assign({}, me.auctionMdl, r.data );
                            } 

                            if( me.type == 'competition' ) {
                                me.offer = Object.assign({}, me.competitionMdl, r.data );
                            } 

                        }

                    }

                    me.isReady = true;
                })
            },


            checkFinished() {
                var now = new Date();

                if( this.$parent.phase.type == "auction" || !this.projectPhase.apply_end ) {

                    var endDate = new Date( this.projectPhase.end_date.split('-').join('/') );


                } else if( this.$parent.phase.type == "competition" ) {

                    var endDate = new Date( this.projectPhase.apply_end.split('-').join('/') );

                }

                var diff = Math.ceil( ( endDate.getTime() - now.getTime() ) / 3600000 );


                if( diff < 0 ) {
                    this.finished = true;
                }

            }

        },

        components : {
            'auction-form'      : require('./AuctionForm.vue').default,
            'competition-form'  : require('./CompetitionForm.vue').default,
            'my-auction-offer'  : require('./MyAuctionOffer.vue').default,
            'my-competition-offer'  : require('./MyCompetitionOffer.vue').default,

        }

    }
</script>
